import {
  ProductBundle, ProductBundleFragment,
  ProductPropertyFragment,
  ProductType,
} from '../../../@types/codegen/graphql';

type IBundle = Partial<ProductBundleFragment> | ProductBundle

/**
 * @Deprecated: use generateProductTitle instead.
 */
export const deprecated_generateProductTitle = (bundle: IBundle): string => {
  const type = bundle?.type;
  const variants: string[] | undefined = bundle?.properties
    ?.filter(property => true === property.isVariant)
    .map<string>(property => {
      const enums = property.descriptor?.enums ?? [];

      return enums
        .filter(penum => -1 !== property.values.indexOf(penum.key))
        .map<string>(penum => penum.title)
        .join(', ');
    });

  return `${type?.manufacturer?.title} ${type?.title} ${variants?.join(' | ') ?? ''}`;
};

export const generateProductTitle = (type: Pick<ProductType, 'manufacturer' | 'title'>, properties: ProductPropertyFragment[]): string => {
  const variants: string[] | undefined = properties
    ?.filter(property => true === property.isVariant)
    .map<string>(property => {
      const enums = property.descriptor?.enums ?? [];

      return enums
        .filter(penum => -1 !== property.values.indexOf(penum.key))
        .map<string>(penum => penum.title)
        .join(', ');
    });

  return `${type?.manufacturer?.title} ${type?.title} ${variants?.join(' | ') ?? ''}`;
};
